import React from "react";
import { Box, Chip, Tooltip } from "@mui/material";
import { statusMeta } from "./postventaUtils";

export default function EstadoPostventaChip({ value, onToggle, disabled }) {
  const meta = statusMeta[value] || statusMeta.EN_ESPERA;
  return (
    <Tooltip title="Tocá para cambiar de estado" arrow>
      <Chip
        clickable
        disabled={disabled}
        onClick={onToggle}
        label={meta.label}
        size="small"
        icon={<Box component="span" sx={{ width: 7, height: 7, borderRadius: "50%", bgcolor: meta.color, ml: 0.3 }} />}
        sx={{
          height: 28,
          px: 0.5,
          color: meta.color,
          bgcolor: meta.bg,
          border: `1px solid ${meta.color}33`,
          fontWeight: 900,
          "& .MuiChip-icon": { color: meta.color },
          "&:hover": { bgcolor: `${meta.color}22` },
        }}
      />
    </Tooltip>
  );
}
